/* Styles for the light theme button */

import { IThemedButtonVariants } from '@belong/types';
import { COLOURS } from '../../helpers';

export const getButtonVariants = (): IThemedButtonVariants => ({
  primary: {
    backgroundColor: COLOURS.BLACK,
    borderColor: COLOURS.BLACK,
    color: COLOURS.BELONG_BLUE,
    hover: {
      backgroundColor: 'transparent',
      borderColor: COLOURS.GREY_700,
      color: COLOURS.BLACK
    },
    disabled: {
      backgroundColor: COLOURS.GREY_200,
      borderColor: COLOURS.GREY_200,
      color: COLOURS.GREY_500
    },
    selected: {
      background: 'transparent',
      border: 'none',
      hover: {
        backgroundColor: 'transparent',
        border: 'none'
      },
      active: {
        backgroundColor: 'transparent',
        border: 'none'
      }
    },
    loading: {
      borderColor: 'transparent',
      color: COLOURS.BELONG_BLUE,
      backgroundColor: COLOURS.GREY_600
    },
    isLightColor: {
      backgroundColor: COLOURS.BELONG_BLUE,
      color: COLOURS.BLACK,

      loading: {
        color: COLOURS.BLACK,
        backgroundColor: COLOURS.WHITE
      },

      hover: {
        backgroundColor: COLOURS.BLACK,
        color: COLOURS.WHITE,
        borderColor: COLOURS.BELONG_BLUE
      },

      active: {
        backgroundColor: COLOURS.BELONG_BLUE_DARK,
        color: COLOURS.BLACK
      }
    }
  },
  secondary: {
    backgroundColor: 'transparent',
    borderColor: COLOURS.BLACK,
    color: COLOURS.BLACK,
    hover: {
      backgroundColor: COLOURS.BLACK,
      borderColor: COLOURS.BLACK,
      color: COLOURS.BELONG_BLUE
    },
    active: {
      borderColor: COLOURS.BLACK
    },
    disabled: {
      backgroundColor: 'transparent',
      borderColor: COLOURS.GREY_300,
      color: COLOURS.GREY_400
    },
    selected: {
      background: 'transparent',
      border: 'none',
      hover: {
        backgroundColor: 'transparent',
        border: 'none'
      },
      active: {
        backgroundColor: 'transparent',
        border: 'none'
      }
    },
    loading: {
      borderColor: 'transparent',
      color: COLOURS.BELONG_BLUE
    },
    isLightColor: {
      backgroundColor: COLOURS.BLACK,
      color: COLOURS.WHITE,
      borderColor: COLOURS.BELONG_BLUE,

      loading: {
        color: COLOURS.BLACK
      },

      hover: {
        backgroundColor: COLOURS.BELONG_BLUE,
        color: COLOURS.BLACK,
        borderColor: COLOURS.BELONG_BLUE
      },

      active: {
        backgroundColor: COLOURS.BLACK,
        color: COLOURS.WHITE,
        borderColor: COLOURS.BELONG_BLUE
      }
    },
    currentSelected: {
      background: COLOURS.LIGHT_GREEN,
      border: 'none',
      hover: {
        background: COLOURS.LIGHT_GREEN,
        border: 'none'
      },
      active: {
        background: COLOURS.LIGHT_GREEN,
        border: 'none'
      }
    }
  },
  tertiary: {
    backgroundColor: COLOURS.BELONG_BLUE_ALT,
    borderColor: COLOURS.BELONG_BLUE_ALT,
    color: COLOURS.BLACK,
    hover: {
      color: COLOURS.BLACK,
      borderColor: 'transparent'
    },
    active: {
      color: COLOURS.BLACK,
      borderColor: COLOURS.BELONG_BLUE_ALT
    },
    focus: {
      color: COLOURS.BLACK,
      borderColor: COLOURS.BELONG_BLUE_ALT
    },
    isLightColor: {
      borderColor: COLOURS.BELONG_BLUE,
      hover: {
        borderColor: 'transparent'
      }
    },
    disabled: {
      color: COLOURS.GREY_400,
      borderColor: COLOURS.GREY_300
    }
  },
  quaternary: {
    color: COLOURS.BELONG_BLUE_ALT,
    focus: {
      color: COLOURS.BELONG_BLUE_ALT
    },
    disabled: {
      color: COLOURS.GREY_400
    }
  }
});
